
























































import { tmCategories } from "@/models/category";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";

@Component({})
export default class App extends Vue {
  public readonly categories = tmCategories;
  public readonly appTitle = "Eventvuel";
  public drawerOpen = false;
  public startPage = true;

  @Watch("$route", { immediate: true })
  public onRouteChanged(to: Route): void {
    this.startPage = to.name === "startPage";
  }
}
